import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ['18'],
    },
  },
  override: {
    classGroups: {
      'font-size': [
        {
          text: ['48', '40', '36', '32', '24', '20', '18', '16', '14', '12', '10', '8'],
        },
      ],
    },
    theme: {
      borderRadius: ['', '0', '2', '4', '6', '8', '10', '12', '16', '20', '24', '32', 'full', 'none'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
